import React from 'react'

import { Skeleton, Stack, StackProps, Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

// ----------------------------------------------------------------------

type SearchNotFoundPropTypes = StackProps & {
  search?: string
  isLoading?: boolean
}

const SearchNotFound: React.FC<SearchNotFoundPropTypes> = ({
  search = ' ',
  isLoading,
  ...props
}) => {
  const { t } = useTranslation()

  const notFoundTitle = (
    <Typography gutterBottom align="center" variant="subtitle1">
      {t('search.notFound')}
    </Typography>
  )

  const notFoundText = (
    <Typography variant="body2" align="center">
      <Trans
        i18nKey="search.notFoundText"
        values={{ value: search }}
        components={{ bold: <b /> }}
      />
    </Typography>
  )

  if (isLoading)
    return (
      <Stack alignItems={'center'} justifyContent={'center'} {...props}>
        <Skeleton>{notFoundTitle}</Skeleton>
        <Skeleton>{notFoundText}</Skeleton>
      </Stack>
    )

  return (
    <Stack alignItems={'center'} justifyContent={'center'} {...props}>
      {notFoundTitle}
      {notFoundText}
    </Stack>
  )
}

export default SearchNotFound
